import { TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { WithExpandCell } from "app/pages/sales-intelligence/common-components/table-cells";
import { NO_DATA_HYPHEN } from "app/pages/sales-intelligence/constants/common";
import type { CompanyDomainValue } from "app/pages/sales-intelligence/domain/leads/types/website";

import { CompanyDomainsSummary } from "./CompanyDomainsSummary";
import { DATA_AUTOMATION_COMPANY_DOMAIN_SINGLE } from "./const";
import { SingleDomainWrapper, StyledDomain } from "./styles";

type Props = {
    value: readonly CompanyDomainValue[] | null | undefined;
    isExpanded: boolean;
    onExpand: VoidFunction;
};

const CompanyDomainsCell = ({ value: companyDomains, onExpand, isExpanded }: Props) => {
    if (!companyDomains || companyDomains.length === 0) {
        return <TextCell>{NO_DATA_HYPHEN}</TextCell>;
    }

    if (companyDomains.length === 1) {
        return (
            <SingleDomainWrapper
                alignItems="center"
                data-automation={DATA_AUTOMATION_COMPANY_DOMAIN_SINGLE}
            >
                <StyledDomain
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon[500]}
                >
                    {companyDomains[0].domain}
                </StyledDomain>
            </SingleDomainWrapper>
        );
    }

    return (
        <WithExpandCell
            isExpanded={isExpanded}
            onClick={onExpand}
        >
            <CompanyDomainsSummary companyDomains={companyDomains} />
        </WithExpandCell>
    );
};

export default CompanyDomainsCell;
